export const MODES_MODAL_VARIFICACION = {
  VALIDAR: 0,
  ERROR: 1,
}
